import { render } from "./UiBlockTextEditor.vue?vue&type=template&id=ff3051fc&scoped=true"
import script from "./UiBlockTextEditor.vue?vue&type=script&lang=js"
export * from "./UiBlockTextEditor.vue?vue&type=script&lang=js"

import "./UiBlockTextEditor.vue?vue&type=style&index=0&id=ff3051fc&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff3051fc"]])

export default __exports__